import React from "react";
import { FeedFriend } from ".";
import { useConnection } from "../context/ConnectionContext";

const FeedNeighbors = () => {
  const { neighbors } = useConnection();
  return (
    <>
      {(neighbors && neighbors?.length > 0 ) ? <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {neighbors.map(neighbor => (
          <FeedFriend key={neighbors.indexOf(neighbor)} info={neighbor} connect={neighbor.mutual + " mutual Connections"} button="Connect" />
        ))}
      </div> : <div className="h-full mt-8 flex justify-center flex-col items-center">
          <h4 className="text-center">
            Record is Empty
          </h4>
        </div>}
    </>
  );
};

export default FeedNeighbors;
